import React from 'react';
import { ArrowUpRight, CheckCircle2 } from 'lucide-react';
import { Button } from './ui/button';
import SectionLabel from './SectionLabel';
import Reveal from './Reveal';
import { CTA_URL } from '../mock';
import { useI18n } from '../i18n/I18nContext';

export default function Situations() {
  const { t } = useI18n();
  const items = t('situations.items') || [];
  return (
    <section className="relative py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5">
        <div className="grid lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-32 space-y-6">
            <SectionLabel>{t('situations.tag')}</SectionLabel>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-semibold text-slate-900 leading-[1.05]">
              {t('situations.title_a')} <span className="text-gradient-green">{t('situations.title_b')}</span>
            </h2>
            <p className="text-slate-700/70 leading-relaxed max-w-md">{t('situations.subtitle')}</p>
            <a href={CTA_URL} target="_blank" rel="noreferrer" className="inline-block">
              <Button className="btn-primary bg-blue-500 hover:bg-blue-600 text-white font-medium rounded-xl h-11 px-5">
                {t('common.free_consultation')}<ArrowUpRight className="ml-1.5 h-4 w-4" />
              </Button>
            </a>
          </div>
          <div className="lg:col-span-7 grid gap-3">
            {items.map((s, i) => (
              <Reveal key={i} delay={i * 40}>
                <div className="group flex items-start gap-4 rounded-2xl border border-blue-500/10 bg-white px-5 py-4 hover:border-blue-500/30 hover:bg-blue-50/50 transition-all">
                  <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-blue-500/10 border border-blue-500/15 group-hover:bg-blue-500/20 transition-colors">
                    <CheckCircle2 className="h-4 w-4 text-blue-600" strokeWidth={1.8} />
                  </div>
                  <p className="text-[15px] text-slate-700 leading-relaxed pt-1">{s}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
